import React from 'react';
import {isMobile} from 'react-device-detect';
import './NoMembersSelectedPopup.scss';

function NoMembersSelectedPopup(props) {
    const {
        onContinue,
        closePopUp,
        onAddMembers,
        onChooseAnotherPackage,
        hasMoreSubscribers = true,
    } = props;

    const handleAddMembers = () => {
          if (closePopUp) {
            closePopUp();
        }
        if (onAddMembers) {
            onAddMembers();
        }
    };

    const handleChooseAnotherPackage = () => {
        if (onChooseAnotherPackage) {
            onChooseAnotherPackage();
        }
    };

    return (
        <div className="no-members-selected-popup">
            {/* Title */}
            <div className='popup-text'>
                <h2 className="popup-title">
                    {hasMoreSubscribers
                        ? isMobile ? (<> שמנו לב שלא צירפת מנויים <br /> לחבילה, האם להמשיך?</>) : (<> שמנו לב שלא צירפת מנויים לחבילה,<br /> האם להמשיך?</>)
                        : 'חבילה זו מתאימה למספר אנשים שטסים יחד, האם להמשיך ברכישת חבילה משפחתית?'
                    }
                </h2>
            </div>

            {/* Buttons */}
            <div className="popup-buttons">
                <button
                    className="continue-btn"
                    onClick={onContinue}
                >
                    כן, בואו נמשיך
                </button>
                <button
                    className="secondary-btn"
                    onClick={hasMoreSubscribers ? handleAddMembers : handleChooseAnotherPackage}
                >
                    {hasMoreSubscribers ? 'אני רוצה לצרף מנויים לחבילה' : 'אבחר חבילה אחרת'}
                </button>
            </div>
        </div>
    );
}

export default NoMembersSelectedPopup;
